import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWidgetColors, saveWidgetColors } from './widget.api';
import type { SaveWidgetColorsRequest } from '@shared/types/dashboard';

export const useWidgetColors = (shop: string) => {
  return useQuery({
    queryKey: ['widgetColors', shop],
    queryFn: () => getWidgetColors(shop),
    enabled: !!shop,
  });
};

export const useSaveWidgetColors = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: SaveWidgetColorsRequest) => saveWidgetColors(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['widgetColors', variables.shop] });
    },
  });
};

